__turbopack_context__.v({
  "cNoData": "style-module-scss-module__ZeButq__cNoData",
  "cNoData__icon": "style-module-scss-module__ZeButq__cNoData__icon",
  "cNoData__icon__large": "style-module-scss-module__ZeButq__cNoData__icon__large",
  "cNoData__icon__medium": "style-module-scss-module__ZeButq__cNoData__icon__medium",
  "cNoData__icon__small": "style-module-scss-module__ZeButq__cNoData__icon__small",
});
